"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Snowflake = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Snowflake_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5.5a.5.5 0 0 0-1 0v1.793L6.354 1.146a.5.5 0 1 0-.707.708L7.5 3.707v3.428L4.533 5.422l-.679-2.534a.5.5 0 1 0-.966.26l.42 1.567-1.554-.897a.5.5 0 1 0-.5.866l1.552.896-1.564.419a.5.5 0 1 0 .259.966l2.53-.678L6.999 8 4.032 9.713l-2.531-.678a.5.5 0 0 0-.26.966l1.566.42-1.553.896a.5.5 0 0 0 .5.866l1.554-.897-.42 1.567a.5.5 0 1 0 .966.258l.679-2.532L7.5 8.866v3.427l-1.853 1.853a.5.5 0 0 0 .707.708L7.5 13.707V15.5a.5.5 0 0 0 1 0v-1.793l1.147 1.147a.5.5 0 0 0 .707-.708L8.5 12.293V8.867l2.969 1.714.678 2.53a.5.5 0 1 0 .966-.259l-.42-1.564 1.552.896a.5.5 0 0 0 .5-.866l-1.554-.897L14.76 10a.5.5 0 1 0-.259-.966l-2.534.679L9 8l2.969-1.714 2.532.679a.5.5 0 0 0 .259-.966l-1.567-.42 1.553-.896a.5.5 0 0 0-.5-.866l-1.552.896.42-1.566a.5.5 0 1 0-.966-.258l-.679 2.531L8.5 7.134V3.707l1.854-1.853a.5.5 0 1 0-.707-.708L8.5 2.293V.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Snowflake_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Snowflake;
exports["default"] = _default;